var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("基地管理")]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { name: "baseProductionData" } } },
                [_vm._v("基地生产数据")]
              ),
              _c("el-breadcrumb-item", [_vm._v("新增基地生产数据")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "show-pager-on-one-page": false, loading: _vm.tableLoading },
        },
        [
          _c(
            "div",
            { staticClass: "wrap-table-info-display" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.addRow },
                },
                [_vm._v(" 继续添加 ")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.resetTableData } },
                [_vm._v(" 重置 ")]
              ),
              _c(
                "div",
                { staticStyle: { position: "absolute", right: "0" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "success" },
                      on: { click: _vm.submitData },
                    },
                    [_vm._v(" 提交 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "farmTitle",
                  width: "100",
                  align: "center",
                  label: "基地名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "种植位置",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "small" },
                            on: {
                              change: _vm.areaIdChanged,
                              focus: function ($event) {
                                return _vm.getIndex(scope.row.$index)
                              },
                            },
                            model: {
                              value: scope.row.areaId,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "areaId", $$v)
                              },
                              expression: "scope.row.areaId",
                            },
                          },
                          _vm._l(_vm.farmAreaList, function (item) {
                            return _c("el-option", {
                              key: item.areaId,
                              attrs: {
                                value: item.areaId,
                                label: item.areaTitle,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "measureTotal",
                  width: "120",
                  align: "center",
                  label: "亩数/总亩数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "品种",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { size: "small" },
                            model: {
                              value: scope.row.categoryId,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "categoryId", $$v)
                              },
                              expression: "scope.row.categoryId",
                            },
                          },
                          _vm._l(_vm.farmCategoryList, function (item) {
                            return _c("el-option", {
                              key: item.categoryId,
                              attrs: {
                                value: item.categoryId,
                                label: item.categoryTitle,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "100",
                  align: "center",
                  label: "品名",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "small" },
                          model: {
                            value: scope.row.goodTitle,
                            callback: function ($$v) {
                              _vm.$set(
                                scope.row,
                                "goodTitle",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.goodTitle",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "定植时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            type: "date",
                            placeholder: "选择日期",
                          },
                          model: {
                            value: scope.row.plantTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "plantTime", $$v)
                            },
                            expression: "scope.row.plantTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "供应开始时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            type: "date",
                            placeholder: "选择日期",
                          },
                          on: {
                            change: _vm.checkStartDateFormat,
                            focus: function ($event) {
                              return _vm.getIndex(scope.row.$index)
                            },
                          },
                          model: {
                            value: scope.row.supplypStarTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "supplypStarTime", $$v)
                            },
                            expression: "scope.row.supplypStarTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "供应结束时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            type: "date",
                            placeholder: "选择日期",
                          },
                          on: {
                            change: _vm.checkEndDateFormat,
                            focus: function ($event) {
                              return _vm.getIndex(scope.row.$index)
                            },
                          },
                          model: {
                            value: scope.row.supplypEndTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "supplypEndTime", $$v)
                            },
                            expression: "scope.row.supplypEndTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyTimes",
                  align: "center",
                  width: "100",
                  label: "供应次数",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "small" },
                          on: {
                            blur: function ($event) {
                              return _vm.supplyBlur(
                                "supplyTimes",
                                scope.row.supplyTimes
                              )
                            },
                            focus: function ($event) {
                              return _vm.getIndex(scope.row.$index)
                            },
                          },
                          model: {
                            value: scope.row.supplyTimes,
                            callback: function ($$v) {
                              _vm.$set(
                                scope.row,
                                "supplyTimes",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.supplyTimes",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  width: "150",
                  align: "center",
                  label: "每次供应产量(斤)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "small" },
                          on: {
                            blur: function ($event) {
                              return _vm.supplyBlur(
                                "supplyTimesProduce",
                                scope.row.supplyTimesProduce
                              )
                            },
                            focus: function ($event) {
                              return _vm.getIndex(scope.row.$index)
                            },
                          },
                          model: {
                            value: scope.row.supplyTimesProduce,
                            callback: function ($$v) {
                              _vm.$set(
                                scope.row,
                                "supplyTimesProduce",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.supplyTimesProduce",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalProduce",
                  align: "center",
                  label: "总产量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "measureProduce",
                  align: "center",
                  label: "亩产",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }